import React, { HTMLProps, useState } from 'react';

export function CreditCardInput(props: HTMLProps<HTMLInputElement>) {
  const [cardNumber, setCardNumber] = useState('');

  return (
    <input
      {...props}
      placeholder="1234 1234 1234 1234"
      autoComplete="cc-number"
      maxLength={19}
      onChange={props.onChange}
      value={cardNumber}
      onInput={(e: React.ChangeEvent<HTMLInputElement>) =>
        setCardNumber(formatCard(e.target.value))
      }
    />
  );
}

function formatCard(cardNumber: string) {
  const parts = cardNumber.match(/\d{1,4}/g);
  return parts ? parts.join(' ') : '';
}
